import { Decorable } from '../../types/decorable';
import { CancellablePromise } from '../../types/cancellable-promise';

import { SLMap } from '../sl-map';
import { LayerRenderResult } from '../../types/layerrenderresult';
import { SLLayer, LayerTypeEnum, LayerGeomtypes } from '../sl-layer';
import { ISLMap } from '../../types/@types/sl-map';
import { ColorClass } from '../../types/color-class';
import { ResultsService, ResultMoment } from '../../services/results.service';
import { BufferSrc } from '../buffersrc';
import { BufferInfo } from '../api-services/layer-api.service';
import { IClearable } from '../../types/iclearable';
import { ISelectionInfo, ISelectionData } from '../synchronizer';
import { MapDataAction } from '../map-actions/map_data-action';
import { LabelStyle, LabelStyleInfo } from '../../types/LabelStyle';
import { thousandSeparatorFormatted } from 'angular-slickgrid';
import { destination, Feature, Point, point } from '@turf/turf';
import { Grid9Position } from '../../types/grid9-position';
import { SnapLayerAPIService } from '../api-services/snap-layer-api.service';
import { SnapPts } from '../drawing/SnapPts';
import { SnapSegs } from '../drawing/SnapSegs';
import { Output } from '@angular/core';
import { EventEmitter } from '@angular/core';


export class SnapLayer extends SLLayer implements IClearable {
  public sourceLayer: SLLayer;
  private vis = false;
  private bufferSrc?: BufferSrc;
  private buffer = 0;
  private centerLat: string;
  private centerLon: string;
  // tslint:disable-next-line: variable-name
  public abilities: Decorable = {
    layer_vis: true,
    include_in_search: false,
    show_labels: false,
    include_in_legend: true,
    tooltip: false
  };
  get layerOn(): boolean {
    return this.vis;
  }
  set layerOn(isVis: boolean) {
    this.vis = isVis;
    if (!!this.sourceLayer) {
      this.snaps = this.map.component.drawPane.GetSnaps()
      this.snaps?.points?.ToggleVis(isVis);
      this.snaps?.segments?.ToggleVis(isVis);

    }
    this.visChange.emit({ layer: this });
  }
  private snaps?: { points?: SnapPts, segments?: SnapSegs }
  SetLayerOn(isVis: boolean, _map?: ISLMap) {
    this.layerOn = isVis;

  }
  GetColor() {
    return '';
  }
  Clear() {
    // select no snap layer
    // clear drawpane snaps
  }

  get opacity(): number {
    if (!!this._myOpacity) {
      return this._myOpacity;
    } else {
      return 0;
    }
  }
  set opacity(level: number) {
    if (this._myOpacity === level) return;
    this._myOpacity = level;
    if (!!this.snaps) {
      this.snaps.points.SetOpacity(this._myOpacity / 100.0);
      this.snaps.segments.SetOpacity(this._myOpacity / 100.0)
    }
    this.change$.emit(this);

  }


  get queryAble(): boolean {
    return false;
  }

  get parentLayer(): string {
    return '';
  }

  get searchable(): boolean {
    return false;
  }

  private _myOpacity: number = 1;
  private snapSvc: SnapLayerAPIService
  constructor(map: ISLMap, snapSvc: SnapLayerAPIService) {
    super(undefined, map, undefined, undefined, undefined, false);
    this._myOpacity = 1;
    this.snapSvc = snapSvc;
    this.change$.emit(this);
    this.Setup();
  }
  get enabled(): boolean {
    return !!this.sourceLayer;
  }
  public enabledChange = new EventEmitter<boolean>();
  get preferredView(): string {
    return 'snap-layer-view';
  }
  get overlayId(): string {
    return '';
  }

  get defaultCriteria(): Array<any> | null {
    return null;
  }

  get description(): string {
    return 'Snap-layer settings';
  }

  set description(_desc: string) {
    return;
  }

  public get id(): string {
    return 'snap-layer';
  }
  public get inheritLabelStyle(): boolean { return false; }
  public get inheritOnly(): boolean { return false; }
  public get labelValueOverride(): boolean { return false; }
  public get labelable(): boolean { return false };
  public get ownerDisplay(): string {
    if (!this.sourceLayer) return '';
    return this.sourceLayer.ownerDisplay;
  }
  public get owner(): string {
    if (!this.sourceLayer) return '';
    return this.sourceLayer.owner;
  }

  get renderId(): string {
    return this.sourceLayer?.identifier;
  }

  get plid(): string {
    return 'snap-layer';
  }
  get name(): string {
    return 'Snap Layer';
  }
  set name(name: string) {
    name = name;
    return;
  }
  get geom(): string {
    if (!this.sourceLayer) return 'snap';
  }
  get type(): number {
    return LayerTypeEnum.Virtual_SnapLayer;
  }

  set type(layerType: number) {
    layerType = layerType;
  }

  get typeString(): string {
    return LayerTypeEnum[LayerTypeEnum.Virtual_SnapLayer];
  }

  get identifier() {
    if (!this.sourceLayer) return 'snap-layer';
    if (this.sourceLayer.isPLayer === true) {
      return this.plid;
    }
    return this.sourceLayer.id;
  }

  get subLayers(): Array<any> {
    return [];

  }
  get subSLLayers(): Array<SLLayer> {
    return [];
  }
  get hasSubLayers(): boolean {
    return false;
  }

  Render(_map?: ISLMap, force: boolean = false) {
    // Reload the snap geometries
  }

  GetFeatures(): Array<any> {
    return [];
  }
  HasFeatures(): boolean {
    return false;
  }
  ZoomToFeatures() {
    // zoom to snap geoms?
  }
  get icon() {
    return 'font-icon';
  }

  get fontIcon() {
    return 'far fa-circle';
  }
  IsVirtual() {
    return true;
  }
  GetLabelInfo(): any {
    return { labelField: '', labelStyle: {} };
  }
  Setup() {
    this.map.snapLayerService.AddLoadListener('snap-layer-view', (svc: SnapLayerAPIService) => {
      this.sourceLayer = svc.GetSnapLayer();
      this.layerOn = true;
      this.enabledChange.emit(this.enabled);
    });
  }
}

